export default {
  dataAmountBoost: {
    id: 'bouygues_flash_offer_data_amount_boost',
    defaultMessage: '{dataAmount}Go',
  },
  subsidyAmountBoost: {
    id: 'bouygues_flash_offer_subsidy_amount_boost',
    defaultMessage: '{subsidy} de réduction',
  },
}
